import { FC } from 'react';

import ACHHeader from 'components/ach-header';
import AdyenACHForm from 'components/adyen-ach-form';
import { ACH_ADD, ACH_ADD_PAY } from 'utils/constants';

interface AchAddProps {
  intent: typeof ACH_ADD | typeof ACH_ADD_PAY;
}

const AchAdd: FC<AchAddProps> = ({ intent }): JSX.Element => (
  <>
    <ACHHeader />
    <AdyenACHForm intent={intent} />
  </>
);

export default AchAdd;
